import JSONPretty from 'react-json-pretty';

export default {
  className: "ErrorLog",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "functionName",
      columnLabel: 'function Name',
  		type: "string"
    },
    {
      columnName: "type",
  		type: "string"
    },
    {
      columnName: "message",
      columnLabel: 'message',
  		type: "string"
    },
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/ErrorLog_schema.js